import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { permissionGuard } from '@abp/ng.core';
import { customAuthGuard } from './guards/custom-auth.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'example',
    loadComponent: () => import('./example/example.component').then(m => m.ExampleComponent),
  },
  {
    path: 'example/:page',
    loadComponent: () => import('./example/example.component').then(m => m.ExampleComponent),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [customAuthGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('@abp/ng.account').then(m => m.AccountModule.forLazy()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@abp/ng.identity').then(m => m.IdentityModule.forLazy()),
    canActivate: [customAuthGuard, permissionGuard],
  },
  {
    path: 'setting-management',
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
    canActivate: [customAuthGuard, permissionGuard],
  },
  // Under Construction routes
  {
    path: 'status',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:Status' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'goals',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:Goals' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'plans',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:Plans' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'reports',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:Reports' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'ai-assistant',
    loadChildren: () => import('./ai-assistant/ai-assistant.module').then(m => m.AiAssistantModule),
    canActivate: [customAuthGuard],
  },
  {
    path: 'people',
    loadComponent: () => import('./people/people.component'),
    canActivate: [customAuthGuard],
  },
  {
    path: 'overview',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:Overview' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'forms/pending',
    loadComponent: () => import('./forms/pending/pending-forms.component'),
    canActivate: [customAuthGuard],
  },
  {
    path: 'forms/builder/:id',
    loadComponent: () => import('./forms/builder/form-builder.component'),
    canActivate: [customAuthGuard],
  },
  {
    path: 'forms/assignments',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:FormAssignments' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'settings/notifications',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:NotificationSettings' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'admin/schools',
    loadComponent: () => import('./admin/schools/schools.component'),
    canActivate: [customAuthGuard],
  },
  {
    path: 'admin/cities',
    loadComponent: () => import('./admin/cities/cities.component'),
    canActivate: [customAuthGuard],
  },
  {
    path: 'admin/grade-levels',
    loadComponent: () => import('./admin/grade-levels/grade-levels.component'),
    canActivate: [customAuthGuard],
  },
  {
    path: 'admin/form-templates',
    loadComponent: () => import('./admin/form-templates/form-templates.component'),
    canActivate: [customAuthGuard],
  },
  {
    path: 'admin/parameters',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:Parameters' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'admin/coaches',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:CoachApprovals' },
    canActivate: [customAuthGuard],
  },
  {
    path: 'admin/logs',
    loadComponent: () => import('./shared/under-construction/under-construction.component'),
    data: { titleKey: '::Menu:SystemLogs' },
    canActivate: [customAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
